// extracted by mini-css-extract-plugin
export default {"container":"img-with-loader_container__eX2TW","image":"img-with-loader_image__Y7lZ9"};